import { extend } from 'vee-validate';
import SchoolService from '@/services/SchoolService';

extend('school_id_unique', {
  validate: (id) => {
    return SchoolService.validateId(id)
      .then((response) => {
        return {
          valid: response.data.isValid,
        };
      })
      .catch(() => {
        return {
          valid: false,
        };
      });
  },
});
